<div class="content">
    <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
    <mat-tab-group mat-align-tabs="start">
        <mat-tab label="List">
            <div class="searchbar">
                <input class="searchInput" type="text" [(ngModel)]="searchUser" placeholder="Search"
                    (keyup)="searchUsersList()" />
                <span class="searchIcon">
                    <img class="flaticon-loupe searchIcn" src="../../assets/images/searcgImg.svg" alt="">
                </span>
            </div>

            <div id="btns-div">
                <button class="serchBtn ignite-style-btn" mat-button color="primary" (click)="editUser()">
                    <mat-icon
                        style="margin-right: 0.2rem; width: 24px !important; height: 24px !important; font-size: 24px !important;">add_circle</mat-icon>
                    Add User
                </button>

                <button class="serchBtn ignite-style-btn" mat-button color="primary" (click)="uploadBulkUsers()">
                    <mat-icon
                        style="margin-right: 0.2rem; width: 24px !important; height: 24px !important; font-size: 24px !important;">add_circle</mat-icon>
                    <span *ngIf="xlsxFileName">Start Importing</span>
                    <span *ngIf="!xlsxFileName">Upload Bulk</span>
                </button>
                <span *ngIf="xlsxFileName" id="xlsx-file-name">{{ xlsxFileName.length >= 15 ? xlsxFileName.slice(0, 15)
                    + ' ...' : xlsxFileName }}</span>
                <button id="reset-zip-btn" mat-button *ngIf="xlsxFileName" (click)="clearXlsxFile()"
                    title="Remove File">
                    Clear File
                </button>

                <button mat-button class="ignite-style-btn" color="primary" (click)="downloadSampleXlsFile()">Download
                    Sample File</button>
                <mat-icon id="file-information-icon" (click)="displayXlsFileInformation()">info</mat-icon>

                <div id="xlsx-file-holder">
                    <input type="file" id="xlsx-file-input" accept=".xls, .xlsx" (change)="xlsxFileChange($event)">
                </div>
            </div>

			<div>
				<button mat-button class="ignite-style-btn" color="primary" (click)="refreshUsers('latest')">Refresh Users</button>
			</div>

			<div *ngIf="isSearchingUser; else notSearchingUser" class="center-align">
				<img src="../../../../../../../assets/gifs/Eclipse-Spinner.gif" alt="Spinner gif" class="spinner_gif">
			</div>

			<ng-template #notSearchingUser>
				<div class="mat-elevation-z8">
					<table style="margin-top: 10px;" mat-table [dataSource]="dataSource" matSort
						(matSortChange)="changeSortTable($event)" class="mat-elevation-z8">
						<ng-container matColumnDef="status">
							<th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
							<td mat-cell *matCellDef="let element">
								<p *ngIf="element.status" class="green-dot">&#x2022;</p>
								<p *ngIf="!element.status" class="red-dot">&#x2022;</p>
							</td>
						</ng-container>

						<ng-container matColumnDef="name">
							<th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
							<td mat-cell *matCellDef="let element"> {{element.name}} </td>
						</ng-container>

						<ng-container matColumnDef="role">
							<th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
							<td mat-cell *matCellDef="let element"> {{ element.role }} </td>
						</ng-container>

						<ng-container matColumnDef="email">
							<th style="padding-left: 10px;" mat-header-cell *matHeaderCellDef mat-sort-header> UserId </th>
							<td style="padding-left: 10px;" class="emailCol" mat-cell *matCellDef="let element">
								{{element?.empCode ? element?.empCode : element?.email | limitString : 10}}..
								<div class="showEmail">
									{{element?.empCode ? element?.empCode : element?.email}}
								</div>
							</td>

						</ng-container>

						<ng-container matColumnDef="location">
							<th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
							<!-- <td mat-cell *matCellDef="let element.level"> {{ element.location ? element.location : "Unavailable" }} </td> -->
							<td mat-cell *matCellDef="let element" class="location-flex emailCol">
								<div *ngFor="let userLevel of element.level">
									<div>{{ userLevel.displayValue }}/</div>
								</div>

								<div class="showEmail">
									<div *ngFor="let userLevel of element.level">
										<div>{{ userLevel.displayValue }}/</div>
									</div>
								</div>
							</td>
						</ng-container>

						<ng-container matColumnDef="actions">
							<th mat-header-cell *matHeaderCellDef class="actions-header">Actions</th>
							<td mat-cell *matCellDef="let element; let i = index">
								<div class="user-actions">
									<button
										mat-icon-button
										(click)="editUser(element)"
										matTooltip="Edit"
										matTooltipClass="compact-action-tooltip"
										matTooltipPosition="above"
										[attr.aria-label]="'Edit ' + (element.name || element.email)"
									>
										<mat-icon class="edit-action-icon">create</mat-icon>
									</button>

									<button
										mat-icon-button
										(click)="deleteUser(element, i)"
										matTooltip="Delete"
										matTooltipClass="compact-action-tooltip"
										matTooltipPosition="above"
										[attr.aria-label]="'Delete ' + (element.name || element.email)"
									>
										<mat-icon class="delete-action-icon">delete</mat-icon>
									</button>

									<span
										*ngIf="canImpersonate"
										matTooltip="Impersonate"
										matTooltipClass="compact-action-tooltip"
										matTooltipPosition="above"
										class="action-tooltip"
									>
										<button
											mat-icon-button
											[disabled]="isImpersonateDisabled(element)"
											(click)="impersonateUser(element)"
											[attr.aria-label]="'Impersonate ' + (element.name || element.email)"
										>
											<mat-icon class="impersonate-action-icon">person</mat-icon>
										</button>
									</span>

									<span
										*ngIf="canImpersonate"
										matTooltip="Change Password"
										matTooltipClass="compact-action-tooltip"
										matTooltipPosition="above"
										class="action-tooltip"
									>
										<button
											mat-icon-button
											[disabled]="isChangePasswordDisabled(element)"
											(click)="changeUserPassword(element)"
											[attr.aria-label]="'Change password for ' + (element.name || element.email)"
										>
											<mat-icon class="password-action-icon">vpn_key</mat-icon>
										</button>
									</span>
								</div>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
					</table>

					<div class="nextPrevBtn" *ngIf="searchUser.length <= 2">
						<span id="curr-pos-text">{{ getPaginationStartDisplay() }} - {{ currentIndex[1] }} of {{ numUsers }}</span>
						<button class="prevBtn" (click)="previousUsers()" [disabled]="!hasPreviousUsers">Previous</button>
						<button class="nextBtn" (click)="nextUsers()" [disabled]="!hasMoreUsers">Next</button>
					</div>

					<!-- <mat-paginator #paginatorUsers="matPaginator" [pageSizeOptions]="[100]"
						showFirstLastButtons></mat-paginator> -->
				</div>
			</ng-template>
        </mat-tab>

        <mat-tab label="Group">
            <div class="mat-elevation-z8">

                <button class="serchBtn" mat-button color="primary" style="height: 44px; margin-top: 30px !important;"
                    (click)="editGroup()">
                    <mat-icon
                        style="margin-right: 0.2rem; width: 24px !important; height: 24px !important; font-size: 24px !important;">add_circle</mat-icon>
                    Add Name
                </button>

                <table style="margin-top: 10px;" mat-table [dataSource]="groupDataSource" matSort>

                    Position Column
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element, let i = index">
                            {{this.paginatorGroups.pageIndex == 0 ? i + 1 : 1 + i + this.paginatorGroups.pageIndex *
                            this.paginatorGroups.pageSize}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    Program Column
                    <ng-container matColumnDef="active">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Active </th>
                        <td mat-cell *matCellDef="let element"> {{element.active}} </td>
                    </ng-container>

                    Edit Button Column
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef> Edit </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary" (click)="editGroup(element)">
                                <mat-icon style="color: #29c96c">create</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    Delete Column
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef> Delete </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary" (click)="deleteGroup(element)">
                                <mat-icon style="color: #FE8C6E">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedGroupColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedGroupColumns;"></tr>
                </table>

                <mat-paginator #paginatorGroups="matPaginator" [pageSizeOptions]="[20]"
                    showFirstLastButtons></mat-paginator>

            </div>
        </mat-tab>

        <mat-tab label="Roles">

            <button class="serchBtn" mat-button color="primary"
                style="height: 44px; margin-left: 30px; margin-top: 30px !important;" (click)="editRole()">
                <mat-icon
                    style="width: 24px !important; height: 24px !important; font-size: 24px !important;">add_circle</mat-icon>
                Add Role
            </button>

            <div class="mat-elevation-z8">
                <table style="margin-top: 10px;" mat-table [dataSource]="dataRoleSource" class="mat-elevation-z8">

                    <!-- <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element, let i = index">
                          {{this.paginatorRoles.pageIndex == 0 ? i + 1 : 1 + i + this.paginatorRoles.pageIndex * this.paginatorRoles.pageSize}}
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Role </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="access">
                        <th mat-header-cell *matHeaderCellDef> Access </th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngFor="let job of element.jobs">
                                <p *ngIf="job.active; else jobInactive">
                                    {{ job.name }}
                                </p>

                                <ng-template #jobInactive>
                                    <div *ngIf="job.subMenu && job.subMenu.length >= 1">
                                        <div *ngFor="let subJob of job.subMenu">
                                            <p *ngIf="subJob.active">
                                                {{ subJob.name }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef> Edit </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary" (click)="editRole(element)">
                                <mat-icon style="color: #29c96c">create</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    Delete Column
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef> Delete </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary" (click)="deleteRole(element)">
                                <mat-icon style="color: #FE8C6E">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedRoleColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedRoleColumns;"></tr>
                </table>
                <mat-paginator #paginatorRoles="matPaginator" [pageSizeOptions]="[20]"
                    showFirstLastButtons></mat-paginator>
            </div>
            <!-- <div class="buttons">
                <div class="btn adminnn">Admin</div>
                <div class="btn userrr">User</div>
            </div> -->
        </mat-tab>

        <mat-tab label="Managers">
			<div *ngIf="areManagersLoading; else managersLoaded" class="center-align">
				<img src="../../../../../../../assets/gifs/Eclipse-Spinner.gif" alt="Spinner gif" class="spinner_gif">
			</div>

			<ng-template #managersLoaded>
				<div class="search_row">
					<div class="searchbar">
						<input class="searchInput" type="text" [(ngModel)]="searchMgr" placeholder="Search"
							(keyup)="filterManagers($event)" />
						<span class="searchIcon">
							<img class="flaticon-loupe searchIcn" src="../../assets/images/searcgImg.svg" alt="">
						</span>
					</div>

					<div class="fl" style="padding: 0px !important;">
						<mat-select placeholder="Select Role" [value]="managerRoleFilterValue">
							<mat-option value="all" (click)="filterManagersByRole('all')">All</mat-option>
							<mat-option [value]="role.id" *ngFor="let role of orgRoles"
								(click)="filterManagersByRole(role.id)">
								{{ role.name }}
							</mat-option>
						</mat-select>
					</div>
				</div>

				<div class="mat-elevation-z8">
					<table style="margin-top: 10px;" mat-table [dataSource]="dataSourceManagers" class="mat-elevation-z8">

						<ng-container matColumnDef="location">
							<th mat-header-cell *matHeaderCellDef> Location </th>
							<td mat-cell *matCellDef="let element" class="location-flex">
								<div *ngFor="let userLevel of element.location">
									<div>{{capitalizeFirstWord(userLevel)}}/</div>
								</div>
							</td>
						</ng-container>

						<ng-container matColumnDef="manager">
							<th style="padding: 10px 10px;
							" mat-header-cell *matHeaderCellDef> Managers </th>
							<td style="padding: 10px 10px;
							" mat-cell *matCellDef="let element">
								<div class="managers" *ngFor="let user of element.managers">
									<div>{{ user.name }}</div>
								</div>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumnsManagers"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumnsManagers;"></tr>
					</table>

					<!-- <mat-paginator #paginatorUsers="matPaginator" [pageSizeOptions]="[100]"
						showFirstLastButtons></mat-paginator> -->
				</div>
			</ng-template>
        </mat-tab>

        <mat-tab label="Program-Access">
            <app-program-access-by-roles></app-program-access-by-roles>
        </mat-tab>

        <!-- <mat-tab label="Region">
            <div class="mat-elevation-z8">
                <table style="margin-top: 24px;" mat-table [dataSource]="regionDataSource" matSort>

                    Position Column
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    Program Column
                    <ng-container matColumnDef="region">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Region </th>
                        <td mat-cell *matCellDef="let element"> {{element.region}} </td>
                    </ng-container>

                    Edit Button Column
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef> Edit </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary">
                                <mat-icon>create</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    Delete Column
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef> Delete </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedRegionColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedRegionColumns;"></tr>
                </table>

            </div>
        </mat-tab> -->
        <!-- <mat-tab label="Rates">Rates</mat-tab> -->
        <!-- <mat-tab label="Programs">
            <div class="mat-elevation-z8">
                <table style="margin-top: 24px;" mat-table [dataSource]="programDataSource" matSort>

                    Position Column
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>

                    <ng-container matColumnDef="program">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.program}} </td>
                    </ng-container>

                    Program Column
                    <ng-container matColumnDef="region">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Region </th>
                        <td mat-cell *matCellDef="let element"> {{element.region}} </td>
                    </ng-container>

                    Edit Button Column
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef> Edit </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary">
                                <mat-icon>create</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    Delete Column
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef> Delete </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button color="primary">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedProgramColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedProgramColumns;"></tr>
                </table>

            </div>
        </mat-tab> -->
    </mat-tab-group>
    <!-- <div class="header">

        <div class="searchbar">
            <input class="searchInput" type="text" placeholder="Search" />
            <span class="searchIcon">
                <i class="flaticon-loupe searchIcn"></i>
            </span>

        </div>

        <button class="serchBtn" mat-button color="primary" style="height: 44px;" (click)="editUser()">
            <mat-icon style="margin-right: 0.2rem;margin-bottom: 4px;">add_circle</mat-icon>
            Add User
        </button>
    </div>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary">
                        <img style="height: 10px; width: 10px;" src="../../../assets/images/new-moon.png"
                            alt="">
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> No. </th>
                <td mat-cell *matCellDef="let element, let i = index">
                  {{this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize}}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <ng-container matColumnDef="brand">
                <th mat-header-cell *matHeaderCellDef> Brand </th>
                <td mat-cell *matCellDef="let element"> {{element.brand}} </td>
            </ng-container>

            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef> Role </th>
                <td mat-cell *matCellDef="let element"> {{element.role}} </td>
            </ng-container>

            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> Edit </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" (click) = editUser(element)>
                        <mat-icon>create</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> Delete </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" (click)="deleteUser(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[20]" showFirstLastButtons></mat-paginator>
    </div> -->
</div>
